import styled from 'styled-components'

export const DisclaimerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-right: 15px;
  
  .DisclaimerContainer__Text {
    color: #B4B26B;
  }
`